import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';
import { articles as allArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'shougong-huangyou-ru-men-zhi-nan': 'https://readdy.ai/api/search-image?query=Artisan%20handmade%20butter%20food%20photography%20on%20rustic%20wooden%20surface%2C%20warm%20golden%20lighting%2C%20cream%20texture%2C%20minimal%20composition%2C%20editorial%20style%2C%20soft%20natural%20light%2C%20elegant%20gourmet%20aesthetic&width=800&height=520&seq=butter-guide-01&orientation=landscape',
  'fa-jiao-huang-you-shen-du-jie-xi': 'https://readdy.ai/api/search-image?query=Artisan%20cultured%20butter%20on%20ceramic%20plate%20with%20fresh%20herbs%2C%20warm%20kitchen%20lighting%2C%20rustic%20wooden%20table%2C%20cream%20and%20golden%20textures%2C%20elegant%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=fermented-butter-01&orientation=landscape',
  'huang-you-su-mian-bao-hong-bei': 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20croissants%20with%20butter%20on%20marble%20surface%2C%20warm%20morning%20light%2C%20flaky%20pastry%20texture%2C%20elegant%20bakery%20aesthetic%2C%20minimal%20composition%2C%20soft%20natural%20lighting&width=800&height=520&seq=butter-croissant-01&orientation=landscape',
  'xiao-pi-liang-huang-you-sheng-chan': 'https://readdy.ai/api/search-image?query=Small%20batch%20artisan%20butter%20production%20in%20clean%20modern%20workshop%2C%20copper%20tools%2C%20cream%20texture%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20food%20photography&width=800&height=520&seq=small-batch-01&orientation=landscape',
  'fa-jiao-huang-you-shi-yan-ri-ji': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20fermentation%20experiment%20with%20glass%20jars%20and%20fresh%20cream%2C%20warm%20natural%20light%2C%20rustic%20wooden%20table%2C%20minimal%20composition%2C%20editorial%20food%20photography&width=800&height=520&seq=ferment-experiment-01&orientation=landscape',
  'da-xiang-cao-huang-you-shi-pu': 'https://readdy.ai/api/search-image?query=Artisan%20garlic%20herb%20compound%20butter%20on%20wooden%20board%20with%20fresh%20herbs%2C%20warm%20kitchen%20lighting%2C%20rustic%20texture%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=garlic-herb-butter-01&orientation=landscape',
  'gan-guo-mi-die-xiang-huang-you': 'https://readdy.ai/api/search-image?query=Artisan%20nut%20and%20honey%20butter%20on%20ceramic%20bowl%20with%20toast%2C%20warm%20morning%20light%2C%20cozy%20kitchen%20scene%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=nut-honey-butter-01&orientation=landscape',
  'huang-you-wen-du-kong-zhi-ji-qiao': 'https://readdy.ai/api/search-image?query=Softened%20butter%20on%20marble%20surface%20with%20baking%20tools%2C%20warm%20kitchen%20lighting%2C%20professional%20food%20photography%2C%20minimal%20composition%2C%20cream%20textures&width=800&height=520&seq=butter-temperature-01&orientation=landscape',
  'hai-yan-jiao-tang-huang-you': 'https://readdy.ai/api/search-image?query=Artisan%20salted%20caramel%20butter%20on%20ceramic%20dish%20with%20sea%20salt%20crystals%2C%20warm%20ambient%20lighting%2C%20rustic%20wooden%20surface%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=salted-caramel-butter-01&orientation=landscape',
  'you-ji-nai-you-xuan-gou-zhi-nan': 'https://readdy.ai/api/search-image?query=Organic%20fresh%20cream%20in%20glass%20bottle%20on%20farm%20table%2C%20pastoral%20setting%2C%20warm%20natural%20light%2C%20minimal%20composition%2C%20editorial%20food%20photography&width=800&height=520&seq=organic-cream-01&orientation=landscape',
  'kai-dian-zheng-jian-ban-li': 'https://readdy.ai/api/search-image?query=Clean%20modern%20artisan%20butter%20workshop%20space%20with%20professional%20equipment%2C%20warm%20lighting%2C%20organized%20workspace%2C%20minimal%20aesthetic%2C%20professional%20photography&width=800&height=520&seq=shop-guide-01&orientation=landscape',
  'song-lu-huang-you-zhi-zuo': 'https://readdy.ai/api/search-image?query=Artisan%20truffle%20butter%20on%20elegant%20ceramic%20plate%20with%20fresh%20truffle%2C%20dark%20moody%20lighting%2C%20luxury%20gourmet%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=truffle-butter-01&orientation=landscape',
  'fa-jiao-huang-you-yu-pu-tong-huang-you': 'https://readdy.ai/api/search-image?query=Two%20types%20of%20artisan%20butter%20side%20by%20side%20on%20rustic%20wooden%20board%2C%20warm%20natural%20light%2C%20minimal%20food%20comparison%20photography&width=800&height=520&seq=cultured-vs-regular-01&orientation=landscape',
  'bu-tong-guo-jia-huang-you-wen-hua': 'https://readdy.ai/api/search-image?query=World%20butter%20varieties%20on%20global%20map%20background%2C%20various%20artisan%20butters%20from%20different%20countries%2C%20warm%20lighting%2C%20editorial%20food%20photography&width=800&height=520&seq=world-butter-01&orientation=landscape',
  'lv-cha-bai-qiao-ke-li-huang-you': 'https://readdy.ai/api/search-image?query=Matcha%20green%20tea%20butter%20on%20ceramic%20plate%20with%20matcha%20powder%2C%20Japanese%20aesthetic%2C%20minimal%20composition%2C%20soft%20natural%20light%2C%20elegant%20food%20photography&width=800&height=520&seq=matcha-butter-01&orientation=landscape',
  'huang-you-ji-shu-ji-ben-gong': 'https://readdy.ai/api/search-image?query=Butter%20creaming%20process%20in%20mixing%20bowl%20with%20baking%20ingredients%2C%20warm%20kitchen%20lighting%2C%20minimal%20composition%2C%20professional%20food%20photography&width=800&height=520&seq=butter-creaming-01&orientation=landscape',
  'pin-pai-gu-shi-yu-ding-wei': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20brand%20packaging%20design%20on%20wooden%20table%2C%20elegant%20branding%2C%20warm%20lighting%2C%20minimal%20composition%2C%20professional%20product%20photography&width=800&height=520&seq=brand-story-01&orientation=landscape',
  'mei-ti-yun-ying-yu-nei-rong-ying-xiao': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20social%20media%20content%20creation%20scene%20with%20camera%20and%20props%2C%20warm%20lighting%2C%20minimal%20composition%2C%20professional%20photography&width=800&height=520&seq=social-media-01&orientation=landscape',
  'shou-gong-huang-you-chang-jian-wen-ti': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20making%20process%20step%20by%20step%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20educational%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=butter-faq-01&orientation=landscape',
  'huang-you-qu-qi-bing-gan-pei-fang': 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20butter%20cookies%20on%20cooling%20rack%2C%20warm%20kitchen%20lighting%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=butter-cookies-01&orientation=landscape',
};

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [selectedSlug, setSelectedSlug] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) {
      setSelectedSlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [selectedSlug]);

  const currentCategory = categories.find((c) => c.slug === selectedSlug) || categories[0];
  const categoryArticles = allArticles.filter((a) => a.category === selectedSlug);

  const handleCategoryClick = (catSlug: string) => {
    setSelectedSlug(catSlug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huangyouzuofang.com/' },
      { '@type': 'ListItem', position: 2, name: currentCategory.name, item: `https://huangyouzuofang.com/category/${selectedSlug}` },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <main>
        <Navbar />
        <div className="pt-16 md:pt-18">
          <div className="bg-background-100">
            <div className="container-site py-10 md:py-14">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-5" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-800 font-medium">{currentCategory.name}</span>
              </nav>

              <div className="flex items-center gap-4 mb-2">
                <span className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                  currentCategory.color === 'primary' ? 'bg-primary-500' :
                  currentCategory.color === 'accent' ? 'bg-accent-500' : 'bg-secondary-500'
                }`}>
                  <i className={`${currentCategory.icon} text-lg text-background-50`}></i>
                </span>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-600">{currentCategory.description}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border-b border-background-200/60">
            <div className="container-site">
              <div className="flex items-center gap-1 overflow-x-auto py-3 flex-wrap">
                {categories.map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => handleCategoryClick(cat.slug)}
                    className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      selectedSlug === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    }`}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="container-site py-12 md:py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article, index) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={articleImages[article.slug] || articleImages['shougong-huangyou-ru-men-zhi-nan']}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading={index > 2 ? 'lazy' : undefined}
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2.5">
                      <span className="text-xs text-foreground-500">{article.date}</span>
                      <span className="text-xs text-foreground-500">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            {categoryArticles.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}